import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "../../../../reducers/initialState";
import { SAVE_OFFER_ASSET_SUCCEEDED } from "features/offer/edit/assets/asset/actionTypes";

export default function reducer(state = initialState.currentOffer.offerSidebarData, action) {
  const initialSidebarData = initialState.currentOffer.offerSidebarData;
  switch (action.type) {
    case actionTypes.LOAD_OFFER_SUMMARY_SUCCEEDED: {
      return {
        ...state,
        offerSummary: action.payload.offerSummary,
        offerSummaryIsLoaded: true
      };
    }

    case actionTypes.LOAD_OFFER_SUMMARY_FAILED: {
      return {
        ...state,
        offerSummary: action.payload.offerSummary,
        offerSummaryIsLoaded: false
      };
    }

    case actionTypes.LOAD_OFFER_KPI_SUCCEEDED: {
      return {
        ...state,
        offerKpi: action.payload.offerKpi
      };
    }

    case SAVE_OFFER_ASSET_SUCCEEDED:
      return {
        ...state,
        offerKpi: initialSidebarData.offerKpi
      };

    case eventTypes.OFFER_SUMMARY_CHANGED: {
      return {
        ...state,
        offerSummary: initialSidebarData.offerSummary,
        offerSummaryIsLoaded: false
      };
    }

    default:
      return state;
  }
}
